<template>
    <div class="flex items-center justify-center" :style="{ gap: `${gap}px` }">
        <img :src="bracket" alt="" class="shrink-0" :style="{ width: `${bracketWidth}px` }" />
        <slot />
        <img
            :src="bracket"
            alt=""
            class="shrink-0 -scale-x-100"
            :style="{ width: `${bracketWidth}px` }"
        />
    </div>
</template>

<script>
import bracket from '@/assets/images/games/killer/splash/bracket.svg'

export default {
    name: 'KillerHudBrackets',
    props: {
        bracketWidth: {
            type: Number,
            default: 26,
        },
        gap: {
            type: Number,
            default: 31,
        },
    },
    data() {
        return {
            bracket,
        }
    },
}
</script>
